import { Route, Router, Routes } from "react-router";
import Goal from "../Goals/Goals";
import CreateGoal from "../Goals/CreateGoal";
import PageNotFound from "../PageNotFound";
import AuthRoute from "../../AuthRoute";
import DefaultContainer from "../DefaultContainer";
import Allroutes from "../../Routes";
import Login from "../../Login";
import Homepage from "../../Homepage";
import Register from "../../Register";
import ForgotPassword from "../../ForgotPassword";
import SuplierR from "../SupplierReports/SuplierReport";
import SuplierReport from "../SupplierReports/SuplierReport";

const PermissionRoutes = ({ permissions, refreshPermission }) => {

    const hasPermission = (permissions, requiredPermission) => {
        const specialPermissions = [
            { "permission_slug": "/assign-permission" },
            { "permission_slug": "/create-role" },
            { "permission_slug": "/create-user" },
            // { "permission_slug": "/sbti" },
            // { "permission_slug": "/supplier-tsp-report" }
        ];

        if (localStorage.getItem('userdetails') !== null ?? JSON.parse(localStorage.getItem('userdetails')).role_name === "SUPERADMIN") {
            specialPermissions.forEach(permission => {
                // Add special permissions only if they are not already present
                if (!permissions.some(p => p.permission_slug === permission.permission_slug)) {
                    permissions.push(permission);
                }
            });
        }

        return permissions.some(permission => permission.permission_slug === requiredPermission);
    };


    return (
        <Routes>
            <Route element={<AuthRoute />}>
                <Route element={<DefaultContainer />}>
                    {Allroutes.map((route, index) => (
                        hasPermission(permissions, route.path) && <Route
                            key={index}
                            path={route.path}
                            element={route.element}
                        />
                    ))}
                    {/* <Route path="/404" component={NotFound} /> */}
                    <Route path="*" element={<PageNotFound />} />
                    {/* <Redirect to="/404" /> */}
                </Route>
            </Route>
            <Route path="/" element={<Login refreshPermission={refreshPermission} />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />

        </Routes>


    );

}

export default PermissionRoutes;